/**
 * Formate une date en format français
 * @param dateString Chaîne de caractères représentant une date
 * @returns Date formatée (ex: 01/02/2023)
 */
export const formatDate = (dateString?: string): string => {
  if (!dateString) return '-';

  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } catch (e) {
    console.error('Erreur lors du formatage de la date:', e);
    return '-';
  }
};

/**
 * Détermine si une date est passée
 * @param dateString Chaîne de caractères représentant une date
 * @returns true si la date est passée, false sinon
 */
export const isDatePassed = (dateString?: string): boolean => {
  if (!dateString) return false;

  try {
    const date = new Date(dateString);
    const today = new Date();
    return date < today;
  } catch (e) {
    console.error('Erreur lors de la comparaison de la date:', e);
    return false;
  }
};